import React from 'react'

import { Button, ConfirmationDialog, useDialogState } from '../../components'
import { useChartLayoutGlobalModel } from './chart-layout-model'

interface Props {
  children: (props: { checkForUnsavedChangesAndClose: () => void }) => React.ReactElement
  onHide: () => void
}

export function PreventClosingUnsavedChanges({ children, onHide }: Props) {
  const { forceGlobalRerender, getIsConfigChanged } = useChartLayoutGlobalModel()
  const confirmationDialogState = useDialogState()

  const checkForUnsavedChangesAndClose = () => {
    if (getIsConfigChanged()) {
      confirmationDialogState.show()
    } else {
      onHide()
    }
  }

  const discardChangesAndHide = () => {
    confirmationDialogState.hide()
    onHide()
    forceGlobalRerender()
  }

  return (
    <>
      {children({ checkForUnsavedChangesAndClose })}
      <ConfirmationDialog
        state={confirmationDialogState}
        aria-label="Unsaved changes"
        title="Unsaved changes"
        actions={
          <>
            <Button data-testid="confirmation-dialog-cancel" onClick={() => confirmationDialogState.hide()}>
              Cancel
            </Button>
            <Button data-testid="confirmation-dialog-delete" onClick={discardChangesAndHide} theme="red">
              Discard changes
            </Button>
          </>
        }
      >
        Are you sure you want to discard changes?
      </ConfirmationDialog>
    </>
  )
}
